import AbstractPolicy from '@/Services/Auth/Policies/AbstractPolicy';

export default class CompanyPolicy extends AbstractPolicy{
    static viewAny(user, model = null) {
        return this._userHasPermission(user, 'company.viewAny');
    }

    static view(user, model = null) {
        return this._userHasPermission(user, 'company.view') ;
    }

    static create(user, model = null) {
        return this._userHasPermission(user, 'company.create');
    }

    static update(user, model = null) {
        return this._userHasPermission(user, 'company.update');
    }

    static delete(user, model = null) {
        return this._userHasPermission(user, 'company.delete');
    }

    static restore(user, model = null) {
        return this._userHasPermission(user, 'company.restore');
    }

    static forceDelete(user, model = null) {
        return this._userHasPermission(user, 'company.forceDelete');
    }
}
